<template>
    <b-card style="border:none;">
        <b-container fluid>
            <b-row style="border-bottom:1px solid #ddd;margin-bottom:2em;">
                    <h3>{{ this.$t('locationManagement') }}</h3>
            </b-row>
            <b-row style="justify-content:space-between;">
                <b-col cols="8">
                    <ul class="nav nav-tabs">
                        <li v-for="(tab,tabKey) in tabs" :key="tabKey" class="nav-item p-2" style="cursor: pointer;" :style="tab.isActive ? tab.style.border : ''">
                            <div @click="activate(tabKey)" :class="{'nav-link': true, 'active': tab.isActive}" :style="tab.isActive ? tab.style.tab : ''">{{ tab.name }}  <b-badge pill :style="tab.isActive ? tab.style.badge : ''">{{tab.data.tableItems.length}}</b-badge></div> 

                        </li>
                    </ul>
                </b-col>
                <b-col cols="4" style="float:right;text-align:right;">
                    <template v-if="tabs.countries.isActive">
                        <b-button key="addCountry" style="background-color:#41B884;" lg="2" class="pb-2" @click="openInsertItemModal()"><img width="20px" height="20px" src="../../assets/icon/addIcon.svg"/> {{ $t('addCountry') }}</b-button>
                    </template>
                    <template v-else-if="tabs.regions.isActive">
                        <b-button key="addRegion" style="background-color:#41B884;" lg="2" class="pb-2" @click="openInsertItemModal()"><img width="20px" height="20px" src="../../assets/icon/addIcon.svg"/> {{ $t('addRegion') }}</b-button>
                    </template>
                    <template v-else-if="tabs.cities.isActive">
                        <b-button key="addCity" style="background-color:#41B884;" lg="2" class="pb-2" @click="openInsertItemModal()"><img width="20px" height="20px" src="../../assets/icon/addIcon.svg"/> {{ $t('addCity') }}</b-button>
                    </template>
                    <template v-else-if="tabs.sectors.isActive">
                        <b-button key="addSector" style="background-color:#41B884;" lg="2" class="pb-2" @click="openInsertItemModal()"><img width="20px" height="20px" src="../../assets/icon/addIcon.svg"/> {{ $t('addSector') }}</b-button>
                    </template>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="my-3" md="2">
                    <b-form-input
                    v-model="searchInput"
                    style="padding: 5px 10px;"
                    :placeholder="$t('search')"
                    @input="filterData"/>
                </b-col>
            </b-row>
            <b-table 
                hover 
                :items="itemsForList(tabs[activeTab].data.tableItems)" 
                :fields="tabs[activeTab].data.tableColumns"
            >   
                <template v-slot:cell(index)="data">
                    <span>{{data.index+1}}</span>
                </template>
                <template v-slot:cell(edit)="data">
                    <div
                        @click="openEditItemModal(data.item)"
                        style="color: #8888; cursor: pointer"
                    >
                        <i class="fas fa-edit fa-lg"></i>
                    </div>
                </template>
            </b-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="itemList"
                align="center"
            ></b-pagination>

            <b-modal 
                :title="getModalTitle()"
                ref="addEditItem"
                size="lg"
                hide-footer 
                centered
                >
                <b-container class="my-4" fluid>
                    <!-- countries tab -->
                    <template v-if="this.tabs.countries.isActive">
                        <form ref="form">
                            <b-form-group
                            v-if="modalType == 'insert'"
                            :label="$t('country')"
                            label-for="country-input"
                            label-class="font-weight-bold pt-0"
                            >
                            <b-form-tags
                                id="country-input"
                                v-model="editedItem.countries"
                                separator=",;"
                                :placeholder="$t('countryTagsExample')"
                                tag-class="tag-country"
                                addButtonVariant="outline-light"
                                addButtonText=""
                                size="lg"
                                input-type="text"
                                :duplicate-tag-text="$t('alreadyEnteredCountry')"
                                disabledAddButton
                                tag-pills
                                no-outer-focus
                                remove-on-delete
                                required
                            >
                            </b-form-tags>
                            </b-form-group>
                            <b-form-group
                            v-else
                            :label="$t('country')"
                            label-for="country-text-input"
                            label-class="font-weight-bold pt-0"
                            >
                                <b-form-input
                                    id="country-text-input"
                                    v-model="editedItem.countries"
                                    :placeholder="$t('country')"
                                >
                                </b-form-input>
                            </b-form-group>
                        </form>
                    </template>
                    <!-- regions tab -->
                    <template v-else-if="this.tabs.regions.isActive">
                        <form ref="form">
                            <b-form-group
                            :label="$t('country')"
                            label-for="region-country-select"
                            label-class="font-weight-bold pt-0"
                            >
                                <b-form-select 
                                id="region-country-select"
                                v-model="editedItem.countryId" 
                                :options="countryOptions" 
                            />
                            </b-form-group>
                            <b-form-group
                            v-if="modalType == 'insert'"
                            :label="$t('regions')"
                            label-for="region-input"
                            label-class="font-weight-bold pt-0"
                            >
                            <b-form-tags
                                id="region-input"
                                v-model="editedItem.regions"
                                separator=",;"
                                :placeholder="$t('regionTagsExample')"
                                tag-class="tag-region"
                                addButtonVariant="outline-light"
                                addButtonText=""
                                size="lg"
                                input-type="text"
                                :duplicate-tag-text="$t('alreadyEnteredRegion')"
                                disabledAddButton
                                tag-pills
                                no-outer-focus
                                remove-on-delete
                                required
                            >
                            </b-form-tags>
                            </b-form-group>
                            <b-form-group
                            v-else
                            :label="$t('region')"
                            label-for="region-text-input"
                            label-class="font-weight-bold pt-0"
                            >
                                <b-form-input
                                    id="region-text-input"
                                    v-model="editedItem.regions"
                                    :placeholder="$t('region')"
                                ></b-form-input>
                            </b-form-group>
                        </form>
                    </template>
                    <!-- cities tab -->
                    <template v-else-if="this.tabs.cities.isActive">
                        <form ref="form">
                            <b-form-group
                            :label="$t('country')"
                            label-for="city-country-select"
                            label-class="font-weight-bold pt-0"
                            >
                                <b-form-select 
                                id="city-country-select"
                                v-model="editedItem.countryId" 
                                :options="countryOptions" 
                            />
                            </b-form-group>
                            <b-form-group
                            :label="$t('region')"
                            label-for="city-region-select"
                            label-class="font-weight-bold pt-0"
                            >
                                <b-form-select
                                :disabled="!editedItem.countryId"
                                v-model="editedItem.regionId" 
                                :options="editedItem.countryId == null ?
                                []: arrangeOptions(editedItem.countryId)" 
                            />
                            </b-form-group>
                            <b-form-group
                            v-if="modalType == 'insert'"
                            :label="$t('cities')"
                            label-for="city-input"
                            label-class="font-weight-bold pt-0"
                            >
                            <b-form-tags
                                id="city-input"
                                v-model="editedItem.cities"
                                separator=",;"
                                :placeholder="$t('cityTagsExample')"
                                tag-class="tag-city"
                                addButtonVariant="outline-light"
                                addButtonText=""
                                size="lg"
                                input-type="text"
                                :duplicate-tag-text="$t('alreadyEnteredCity')"
                                disabledAddButton
                                tag-pills
                                no-outer-focus
                                remove-on-delete
                                required
                            >
                            </b-form-tags>
                            </b-form-group>
                            <b-form-group
                            v-else
                            :label="$t('city')"
                            label-for="city-text-input"
                            label-class="font-weight-bold pt-0"
                            >
                                <b-form-input
                                    id="city-text-input"
                                    v-model="editedItem.cities"
                                    :placeholder="$t('city')"
                                >
                                </b-form-input>
                            </b-form-group>
                        </form>
                    </template>
                    <!-- sectors tab -->
                    <template v-else-if="this.tabs.sectors.isActive">
                        <form ref="form">
                            <b-form-group
                            :label="$t('sectorName')"
                            label-for="sector-name-input"
                            label-class="font-weight-bold pt-0"
                            >
                                <b-form-input id="sector-name-input" v-model="editedItem.name" required/>
                            </b-form-group>
                            <b-form-group
                            v-if="modalType == 'insert'"
                            :label="$t('sectorDescription')"
                            label-for="sector-description-input"
                            label-class="font-weight-bold pt-0"
                            >
                                <b-form-input id="sector-description-input"  v-model="editedItem.description" required/>
                            </b-form-group>
                        </form>
                    </template>
                </b-container>
                <hr style="padding-top:5px;">
                <b-row align-h="end">
                    <b-col cols="3">
                        <b-btn size="md" class="mt-3" variant="outline-success" block @click="closeAddEditModal()">{{$t('cancel')}}</b-btn>
                    </b-col>
                    <b-col cols="3">
                        <b-btn size="md" class="mt-3" variant="danger" v-if="modalType == 'edit'" block @click="deleteItem(editedItem.id)">{{$t('delete')}}</b-btn>
                    </b-col>
                    <b-col cols="3">
                        <b-btn size="md" class="mt-3" style="background-color:#41B884;" block @click="saveItem()">{{this.modalType == 'edit' ? $t('update'):$t('add')}}</b-btn>
                    </b-col>
                </b-row>
            </b-modal>



        </b-container>
    </b-card>
</template>

<script>
import _ from 'lodash';
//import moment from 'moment';

export default {
    name: 'Locations',
    data() {
        return {
            tabs:{
                countries:{
                    isActive:true,
                    data: {
                        tableColumns: [
                            {
                                label: '#',
                                key: 'index',
                                thClass: 'table-point-th',
                                stickyColumn: true
                            },
                            {
                                label: this.$t('country'),
                                key: 'name',
                                sortable: true,
                                thClass: 'table-point-th',
                                stickyColumn: true
                            },
                            {
                                label: this.$t('edit'),
                                key: 'edit',
                                thClass: 'table-point-th',
                                stickyColumn: true
                            }
                        ],
                        tableItems: []
                    },
                    name: this.$t('countries'),
                    style:{
                        border:{'border-bottom':'3px solid #41B884'},
                        tab:{'color':'#41B884'},
                        badge:{'background-color':'#41B884'}
                    }
                },
                regions:{
                    isActive:false,
                    data: {
                        tableColumns: [
                            {
                                label: '#',
                                key: 'index',
                                thClass: 'table-point-th',
                                stickyColumn: true
                            },
                            {
                                label: this.$t('region'),
                                key: 'name',
                                sortable: true,
                                thClass: 'table-point-th',
                                stickyColumn: true
                            },
                            {
                                label: this.$t('country'),
                                key: 'countryName',
                                sortable: true,
                                thClass: 'table-point-th',
                                stickyColumn: true
                            },
                            {
                                label: this.$t('edit'),
                                key: 'edit',
                                thClass: 'table-point-th',
                                stickyColumn: true
                            }
                        ],
                        tableItems: []
                    },
                    name: this.$t('regions'),
                    style:{
                        border:{'border-bottom':'3px solid #41B884'},
                        tab:{'color':'#41B884'},
                        badge:{'background-color':'#41B884'}
                    }
                },
                cities:{
                    isActive:false,
                    data: {
                        tableColumns: [
                            {
                                label: '#',
                                key: 'index',
                                thClass: 'table-point-th',
                                stickyColumn: true
                            },
                            {
                                label: this.$t('city'),
                                key: 'name',
                                sortable: true,
                                thClass: 'table-point-th',
                                stickyColumn: true
                            },
                            {
                                label: this.$t('region'),
                                key: 'regionName',
                                sortable: true,
                                thClass: 'table-point-th',
                                stickyColumn: true
                            },
                            {
                                label: this.$t('country'),
                                key: 'countryName',
                                sortable: true,
                                thClass: 'table-point-th',
                                stickyColumn: true
                            },
                            {
                                label: this.$t('edit'),
                                key: 'edit',
                                thClass: 'table-point-th',
                                stickyColumn: true
                            }
                        ],
                        tableItems: []
                    },
                    name: this.$t('cities'),
                    style:{
                        border:{'border-bottom':'3px solid #41B884'},
                        tab:{'color':'#41B884'},
                        badge:{'background-color':'#41B884'}
                    },
                },
                sectors:{
                    isActive:false,
                    data: {
                        tableColumns: [
                            {
                                label: '#',
                                key: 'index',
                                thClass: 'table-point-th',
                                stickyColumn: true
                            },
                            {
                                label: this.$t('sector'),
                                key: 'name',
                                sortable: true,
                                thClass: 'table-point-th',
                                stickyColumn: true
                            },
                            {
                                label: this.$t('edit'),
                                key: 'edit',
                                thClass: 'table-point-th',
                                stickyColumn: true
                            }
                        ],
                        tableItems: []
                    },
                    name: this.$t('sectors'),
                    style:{
                        border:{'border-bottom':'3px solid #41B884'},
                        tab:{'color':'#41B884'},
                        badge:{'background-color':'#41B884'}
                    },
                }
            },
            activeTab:'countries',
            currentPage: 1,
            perPage: 10,
            countryOptions: [],
            editedItem: {
                id: null
            },
            modalType: null,
            searchInput: '',
            totalRows: 0
            
        };
    },
    methods: {
        
        // arranges the region dropdown and filters it based on country
        arrangeOptions(countryId){
            let selectData;
            selectData = _.filter(this.tabs.regions.data.tableItems, item => {
                return item.countryId == countryId;
            });
            let options = _.map(selectData, selectItem => {
                return selectItem = {value:selectItem.id, text:this.$t(selectItem.name), disabled: false};
            });
            return [{value: null, text: this.$t('choose'), disabled: true}, ...options];
        },
        // gets modal title based on selected tab
        getModalTitle(){
            return this.$t(this.activeTab);
        },
        closeAddEditModal(){
            this.$refs.addEditItem.hide();
        },
        activate(key){
            this.activeTab = key;
            this.currentPage = 1;
            _.each(this.tabs, (tab,tabKey)=> {
                tab.isActive = key==tabKey;
            });
        },
        filterData(){
            this.currentPage = 1;
            this.$forceUpdate();
        },
        itemsForList(data){
            let searchedData = this.searchData(data);
            this.totalRows = searchedData.length;
            return searchedData.slice(
                (this.currentPage - 1) * this.perPage,
                this.currentPage * this.perPage,
            );
        },
        searchData(data){
            if (this.searchInput.length < 1) {
                return data
            } else {
                switch(this.activeTab) {
                    case 'countries':
                    case 'sectors':
                        return _.filter(data, o => {
                            return (
                                _.includes(_.toLower(o.name), _.toLower(this.searchInput))
                            )
                        });
                    case 'regions':
                        return _.filter(data, o => {
                            return (
                                _.includes(_.toLower(o.name), _.toLower(this.searchInput))
                                || _.includes(_.toLower(o.countryName), _.toLower(this.searchInput))
                            )
                        });
                    case 'cities':
                        return _.filter(data, o => {
                            return (
                                _.includes(_.toLower(o.name), _.toLower(this.searchInput))
                                || _.includes(_.toLower(o.countryName), _.toLower(this.searchInput))
                                || _.includes(_.toLower(o.regionName), _.toLower(this.searchInput))
                            )
                        });
                    default:
                        return data;
                }
            }
        },
        openInsertItemModal(){
            if(this.activeTab == 'countries'){
                this.editedItem = {countries:[]};
            }
            else if(this.activeTab == 'regions'){
                this.editedItem = {regions:[], countryId: null};
            }
            else if(this.activeTab == 'cities'){
                this.editedItem = {cities:[], regionId: null};
            }
            else {
                this.editedItem = {name:'', description:''};
            }
            
            this.modalType = 'insert';
            this.$refs.addEditItem.show();
        },
        openEditItemModal(selectedItem){
            if(this.activeTab == 'countries'){
                this.editedItem = {countries:selectedItem.name};
            }
            else if(this.activeTab == 'regions'){
                this.editedItem = {regions: selectedItem.name, countryId: selectedItem.countryId};
            }
            else if(this.activeTab == 'cities'){
                this.editedItem = {cities: selectedItem.name, regionId: selectedItem.regionId, countryId: selectedItem.countryId};
            }
            else {
                this.editedItem = {name:selectedItem.name, description:selectedItem.description};
            }
            
            this.editedItem.id = selectedItem.id;
            this.modalType = 'edit';
            this.$refs.addEditItem.show();
        },
        saveItem(){
            if (this.modalType == 'edit') {
                this.editItem();
            } else {
                this.insertItem();
            }
        },
        insertItem(){
            this.$Progress.start();
            switch (this.activeTab) {
                case 'countries':
                    return this.axios.post('/countries', this.editedItem).then(() => {
                        this.$Progress.finish();
                        this.$refs.addEditItem.hide();
                        this.init();
                    });
                case 'regions':
                    return this.axios.post('/regions', this.editedItem).then(() => {
                        this.$Progress.finish();
                        this.$refs.addEditItem.hide();
                        this.init();
                    });
                case 'cities':
                    return this.axios.post('/cities', this.editedItem).then(() => {
                        this.$Progress.finish();
                        this.$refs.addEditItem.hide();
                        this.init();
                    });
                case 'sectors':
                    return this.axios.post('/sector', this.editedItem).then(() => {
                        this.$Progress.finish();
                        this.$refs.addEditItem.hide();
                        this.init();
                    });
                default:
                    this.$Progress.finish();
                    this.$refs.addEditItem.hide();
                    break;
            }
            
        },
        editItem(){
            this.$Progress.start();
            switch (this.activeTab) {
                case 'countries':
                    return this.axios.put('/country', {id: this.editedItem.id, name: this.editedItem.countries}).then(() => {
                        this.$Progress.finish();
                        this.$refs.addEditItem.hide();
                        this.init();
                    });
                case 'regions':
                    return this.axios.put('/region', {id: this.editedItem.id, name: this.editedItem.regions, countryId: this.editedItem.countryId}).then(() => {
                        this.$Progress.finish();
                        this.$refs.addEditItem.hide();
                        this.init();
                    });
                case 'cities':
                    return this.axios.put('/city', {id: this.editedItem.id, name: this.editedItem.cities, regionId: this.editedItem.regionId}).then(() => {
                        this.$Progress.finish();
                        this.$refs.addEditItem.hide();
                        this.init();
                    });
                case 'sectors':
                    return this.axios.put('/sector', this.editedItem).then(() => {
                        this.$Progress.finish();
                        this.$refs.addEditItem.hide();
                        this.init();
                    });
                default:
                    this.$Progress.finish();
                    this.$refs.addEditItem.hide();
                    break;
            }
        },
        // checks if country has any regions or region has any cities under them
        // if there is no connection delete process starts
        deleteItem(id){
            this.$Progress.start();
            
            switch (this.activeTab) {
                case 'countries':
                    if(_.size(_.filter(this.tabs.regions.data.tableItems, item => {
                        return item.countryId == id
                    })) == 0) {
                        return this.axios.delete(`/country/${id}`).then(() => {
                            this.$Progress.finish();
                            this.$refs.addEditItem.hide();
                            this.init();
                        });
                    } 
                    else {
                        this.$Progress.finish();
                        return this.$message({
                            type: 'error',
                            message: this.$t('countryDeleteError')
                        });
                    }
                case 'regions':
                    if(_.size(_.filter(this.tabs.cities.data.tableItems, item => {
                        return item.regionId == id
                    })) == 0){
                        return this.axios.delete(`/region/${id}`).then(() => {
                            this.$Progress.finish();
                            this.$refs.addEditItem.hide();
                            this.init();
                        });
                    } 
                    else {
                        this.$Progress.finish();
                        return this.$message({
                            type: 'error',
                            message: this.$t('regionDeleteError')
                        });
                    }
                case 'cities':
                    return this.axios.delete(`/city/${id}`).then(() => {
                        this.$Progress.finish();
                        this.$refs.addEditItem.hide();
                        this.init();
                    });
                case 'sectors':
                    return this.axios.delete(`/sector/${id}`).then(() => {
                        this.$Progress.finish();
                        this.$refs.addEditItem.hide();
                        this.init();
                    });
                default:
                    this.$Progress.finish();
                    this.$refs.addEditItem.hide();
                    break;
            }

            /*
            
            */
        },
        prepareData(data){
            this.tabs.countries.data.tableItems = _.get(data, 'countries');
            this.tabs.regions.data.tableItems = _.get(data, 'regions');
            this.tabs.cities.data.tableItems = _.get(data, 'cities');
            this.tabs.sectors.data.tableItems = _.get(data, 'sectors');

            let cOptions = _.map(_.get(data, 'countries'), country => {
                return country = {value:country.id, text:country.name, disabled: false};
            });
            this.countryOptions = [{value: null, text: this.$t('choose'), disabled: true}, ...cOptions];
        },
        init() {
            this.$Progress.start();
            return this.axios.get('/getAllLocationsAndSectors').then(({data}) => {
                this.prepareData(data);
                this.$Progress.finish();
            });
        }
    },
    watch:{

    },
    created(){
        this.init()
    }
        
};
</script>

<style lang="scss" scoped>
/deep/ .page-item.active .page-link {
    background-color: #41B884;
    border-color: #41B884;
}
/deep/ .page-link {
    color: #41B884;
    border-color: #41B884;
}
/deep/ .page-item.disabled .page-link {
    color: #41B884;
    border-color: #41B884;
}
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "locationManagement": "Lokasyon Yönetimi",
            "addCountry": "Ülke Ekle",
            "addRegion": "Bölge Ekle",
            "addCity": "Şehir Ekle",
            "addSector": "Sektör Ekle",
            "sectorName": "Sektör Adı",
            "sectorDescription": "Sektör Açıklaması",
            "countryTagsExample": "Almanya, Fransa, İspanya...",
            "alreadyEnteredCountry": "Bu ülke listede ekli",
            "regionTagsExample": "Marmara, Karadeniz, İç Anadolu...",
            "alreadyEnteredRegion": "Bu bölge listede ekli",
            "cityTagsExample": "İstanbul, Ankara, İzmir...",
            "alreadyEnteredCity": "Bu şehir listede ekli...",
            "countryDeleteError": "Bu ülkeye bağlı olan bölgeler olduğu için silinemedi.",
            "regionDeleteError": "Bu bölgeye bağlı olan şehirler olduğu için silinemedi."
        },
        "en": {
            "locationManagement": "Location Management",
            "addCountry": "Add Country",
            "addRegion": "Add Region",
            "addCity": "Add City",
            "addSector": "Add Sector",
            "sectorName": "Sector Name",
            "sectorDescription": "Sector Description",
            "countryTagsExample": "Germany, United Kingdom, Spain...",
            "alreadyEnteredCountry": "You have already entered this country",
            "regionTagsExample": "California, Colorado, New York...",
            "alreadyEnteredRegion": "You have already entered this region",
            "cityTagsExample": "Los Angeles, San Francisco, San Diego...",
            "alreadyEnteredCity": "You have already entered this city",
            "countryDeleteError": "Could not delete because there are regions dependent on this country.",
            "regionDeleteError": "Could not delete because there are cities dependent on this region."
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/Locations.vue